module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/right_arrow-b71951f0679c0cfd62ca0fc563c97006.svg&quot;;"